// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    background-color: #F7F7F9;
    font-size: 16px;
}

h1 {
    font-size: 1.5rem;
}

h2 {
    font-size: 1.3rem;
    margin-top: 18px;
}

h3 {
    font-size: 1.15rem;
    margin-top: 18px;
}

h4 {
    font-size: 1.05rem;
}

/* Loading spinner animations */
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Products loading states */
.products-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  font-size: 16px;
  color: #666;
}

/* Pagination improvements for mobile responsiveness */
nav[aria-label="Page navigation example"] {
  position: relative !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 10px !important;
  z-index: 1 !important;
}

@media (min-width: 768px) {
  nav[aria-label="Page navigation example"] {
    position: absolute !important;
    top: 135px !important;
    right: 50px !important;
    flex-direction: row !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

nav[aria-label="Page navigation example"] .form-group {
  padding-top: 5px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin-bottom: 0 !important;
}

nav[aria-label="Page navigation example"] .pagination {
  margin-bottom: 0 !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
}

/* Ensure pagination items don't get too small on mobile */
@media (max-width: 767px) {
  nav[aria-label="Page navigation example"] .pagination .page-link {
    padding: 8px 12px !important;
    min-width: 40px !important;
    text-align: center !important;
  }
}

.btn-group {
    /*z-index: 0;*/
}

.hover:hover {
    cursor: pointer
}

.pagination>li.active>a {
    background-color: #2A7013 !important;
    color: white;
    border: 1px solid #ECEEEF !important;
}

.pagination>li.active>a:hover {
    background-color: #2A7013;
    color: white;
    border: 1px solid #ECEEEF;
}

.navbar-fixed-top {
    background-color: white;
    /*z-index: 2;*/
}

.atlas-detailed-list {}

.new-badge, .clearance-badge, .scratch-and-dent-badge {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #2A7013;
    background: url('https://atlastrailer.s3.amazonaws.com/img/new-badge.png') no-repeat;
    background-size: contain;
    color: white;
    padding: 2px 4px;
    font-size: 0.8rem;
    margin-top: -10px;
    border-radius: 2px;
    width: 80px;
    height: 140px;
}

.small {
    width: 50px;
    height: 85px;
}

.clearance-badge{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    left: 0;
    top: 0;
    background: url('https://atlastrailer.s3.amazonaws.com/img/clearance-badge.png') no-repeat;
    background-size: contain;
    margin-left: -10px;
    width: 90px;
    height: 140px;
}

.scratch-and-dent-badge {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    left: 0;
    top: 0;
    background: url('https://atlastrailer.s3.amazonaws.com/img/scratch-and-dent.png') no-repeat;
    background-size: contain;
    margin-left: -8px;
    margin-top: -25px;
    width: 99px;
    height: 151px;
}

.atlas-detailed-list-product {
    position: relative;
    background-color: white;
    display: flex;
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
    box-shadow: 1px 1px 2px #ddd;
}

.atlas-primary-nav-search-form {
    background-color: #F5F5F5;
    padding: 0;
    display: flex;
    margin: 0;
    width: 50vw;
    box-shadow: 1px 1px 2px #ddd;
    transition: box-shadow 0.2s;
    align-items: center;
}

.atlas-primary-nav-search-form.atlas-primary-nav-search-form--focus {
    box-shadow: 1px 1px 5px #999;
    transition: box-shadow 0.2s;
}

.atlas-select {
    height: 30px
}

.atlas-search-input {
    border: 0 none;
    flex: 1;
    background-color: transparent;
    margin: 8px 14px;
    margin-left: 0;
    font-size: 1.1rem;
    color: black;
}

.atlas-search-input-icon {
    margin-left: 18px;
    margin-right: 18px;
    height: 18px;
}

.atlas-search-input:focus {
    outline: 0;
}

.atlas-search-input::-webkit-input-placeholder,
.atlas-search-input::-moz-placeholder,
.atlas-search-input:-ms-input-placeholder {
    color: black;
}

.atlas-primary-nav {
    overflow: auto;
    display: flex;
    align-items: center;
    padding: 16px;
}

.atlas-primary-nav-logo {
    flex: 1;
    margin-left: 12px;
}

.atlas-secondary-nav {
    background-color: #2D6F1B;
    overflow: visible;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 12px;
    font-size: 0.92rem;
    transition: all 0.5s ease;
    min-height: 32px;
    flex-wrap: nowrap;
    position: relative;
}

/* Mobile Navigation Styles */
/* =============================================================================
   NAVIGATION SYSTEM - Clean rebuild
   ============================================================================= */

/* Base Navigation Container */
.atlas-secondary-nav {
    position: relative;
    background-color: #2D6F1B;
    padding: 0 15px;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Mobile Navigation Toggle (Hamburger) */
.atlas-mobile-nav-toggle {
    display: none;
    flex-direction: column;
    background: transparent;
    border: none;
    padding: 8px;
    cursor: pointer;
    z-index: 1001;
    position: relative;
}

.atlas-hamburger-line {
    width: 24px;
    height: 3px;
    background-color: white;
    margin: 2px 0;
    transition: 0.3s ease;
    display: block;
}

/* Hamburger Animation */
.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(1) {
    transform: rotate(-45deg) translate(-5px, 6px);
}

.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(2) {
    opacity: 0;
}

.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(3) {
    transform: rotate(45deg) translate(-5px, -6px);
}

/* Desktop Navigation Content */
.atlas-nav-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.atlas-nav-content ul.nav {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    align-items: center;
}

.atlas-nav-content ul.navbar-nav {
    flex-direction: row;
}

.atlas-nav-content li.nav-item {
    margin: 0 2px;
}

.atlas-secondary-nav-link {
    display: inline-block;
    padding: 12px 16px;
    color: white;
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: background-color 0.2s ease;
    white-space: nowrap;
}

.atlas-secondary-nav-link:hover,
.atlas-secondary-nav-link:focus {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
    text-decoration: none;
}

/* Right-side navigation */
.atlas-nav-content .pull-right {
    margin-left: auto;
}

/* Mobile Overlay */
.atlas-nav-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.atlas-nav-overlay--visible {
    display: block;
}

/* =============================================================================
   MOBILE RESPONSIVE DESIGN
   ============================================================================= */

@media (max-width: 992px) {
    /* Show hamburger menu */
    .atlas-mobile-nav-toggle {
        display: flex;
    }
    
    /* Transform nav content into mobile menu */
    .atlas-nav-content {
        position: fixed;
        top: 84px;
        left: -100%;
        width: 100%;
        height: calc(100vh - 84px);
        background-color: #2D6F1B;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 20px 0;
        transition: left 0.3s ease;
        z-index: 1000;
        overflow-y: auto;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
    }
    
    /* Show mobile menu when open */
    .atlas-nav-content--open {
        left: 0;
    }
    
    /* Mobile navigation lists */
    .atlas-nav-content ul.nav,
    .atlas-nav-content ul.navbar-nav {
        flex-direction: column;
        width: 100%;
        margin: 0 0 20px 0;
    }
    
    .atlas-nav-content li.nav-item {
        width: 100%;
        margin: 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    
    .atlas-secondary-nav-link {
        padding: 18px 20px;
        width: 100%;
        text-align: left;
        display: block;
        font-size: 18px;
        white-space: normal;
    }
    
    .atlas-secondary-nav-link:hover {
        background-color: rgba(255, 255, 255, 0.15);
    }
    
    /* Right navigation in mobile */
    .atlas-nav-content .pull-right {
        margin-left: 0;
        margin-top: 20px;
        border-top: 2px solid rgba(255, 255, 255, 0.2);
        padding-top: 20px;
    }
}

/* Additional responsive breakpoint for tablet optimization */
@media (max-width: 1200px) and (min-width: 993px) {
    .atlas-secondary-nav {
        padding: 0 8px;
    }
    
    .atlas-secondary-nav-link {
        padding: 8px 10px;
        font-size: 15px;
    }
}

.atlas-super-list {
    list-style: decimal !important;
    /* color: forestgreen; */
    margin-left: 1rem;
}

/* .atlas-secondary-nav li.active-link {
    background-color: #1e500e;
} */

.atlas-compact-item-hover,
.table-striped tbody tr:nth-of-type(odd).atlas-compact-item-hover {
    background-color: #eee;
}

.atlas-primary-nav-cart-icon-container {
    display: flex;
    flex: 1;
    justify-content: end;
    align-items: center;
    text-align: right;
    margin-right: 12px;
    max-width: 40px;
}

.atlas-primary-nav-inbox-icon-container {
    display: flex;
    flex: 1;
    justify-content: end;
    align-items: center;
    text-align: right;
    margin-right: 12px;
}

.atlas-primary-nav-cart-icon-link {
    flex: 1;
    position: relative;
}

.atlas-primary-nav-cart-icon {
    height: 30px;
}

.atlas-secondary-nav-link {
    background: transparent;
    border: 0 none;
    padding: 8px 12px;
    color: white;
    opacity: 0.85;
    white-space: nowrap;
    display: block;
}

.atlas-secondary-nav-link:hover {
    color: white;
    opacity: 1;
    text-decoration: none;
}

.atlas-secondary-nav-link.active,
.atlas-secondary-nav-link:focus,
.atlas-secondary-nav-link:active {
    color: white;
    opacity: 1;
    text-decoration: none;
}

.atlas-products {
    flex: 1;
    padding: 12px;
    padding-top: 0;
}

.atlas-login-error {
    color: red;
    font-size: 0.9rem;
    margin-top: 12px;
}

.atlas-login-logo {
    width: 238px;
    height: 66px;
}

button {
    padding: 0;
    border: 0 none;
    background-color: transparent;
}

.atlas-list-nav {
    background-color: #F7F7F9;
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
}

.atlas-list-toggle {
    font-size: 0.9rem;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #ECEEEF;
    box-shadow: 0px 0px 2px #ddd;
    -webkit-transition: all 0.1s;
    transition: all 0.1s;
}

.atlas-list-toggle:focus {
    outline: none;
    border-color: #7DBBFD;
    box-shadow: 0px 0px 3px #7DBBFD;
    -webkit-transition: all 0.1s;
    transition: all 0.1s;
}

.atlas-list-toggle:active {
    outline: none;
    border: 1px solid #7DBBFD;
    box-shadow: 0px 0px 9px #7DBBFD;
    -webkit-transition: all 0.1s;
    transition: all 0.1s;
}

.atlas-list-toggle-option {
    display: inline-flex;
    background-color: white;
    padding: 4px 12px;
}

.atlas-list-toggle-option--active {
    background-color: #2A7013;
    color: white;
}

.atlas-detailed-result {
    padding: 4px 8px;
}

.atlas-detailed-result-title {
    font-size: 1.1rem;
}

.atlas-detailed-list-product-image-container {
        max-width: 100%;
      width:250px;
      margin-right: 12px;
    text-align: center;
}

.atlas-detailed-list-product-image {
    object-fit:contain;           
      max-width: 100%;
    width:250px;
    margin-left: auto;
    margin-right: auto;
}

.atlas-detailed-list-product-info {
    flex: 1;
}

.atlas-detailed-result-description {
    font-size: 0.85rem;
}

.atlas-detailed-result-mfg {
    color: #2A7013;
}

.atlas-detailed-result-table {
    table-layout: fixed;
    margin-top: 8px;
    margin-bottom: 0;
}

.atlas-no-results {
    font-size: 1.5rem;
    margin-top: 100px;
    text-align: center;
}


/* bootstrap override :( */

.breadcrumb>.active,
.breadcrumb>.active a:active,
.breadcrumb>.active a:focus {
    font-weight: bold;
    text-decoration: none;
    color: #0275d8;
}

.CategoryChildren-list {
    background-color: white;
    margin-bottom: 16px;
    padding: 12px 32px;
    margin-top: 12px;
}

.CategoryChildren-filled-list-item {
    margin-bottom: 16px;
}

.CategoryChildren-filled-list-item-link {
    color: black;
    font-weight: bold;
}

.CategoryChildren-list-item-link:hover {
    color: inherit;
}

.CategoryChildren-columned-list {
    list-style: none;
    padding-left: 16px;
    -webkit-columns: 275px 4;
    -moz-columns: 275px 4;
    columns: 275px 4;
}

.CategoryChildren-list-item {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
}

.CategoryGrandchildren-list {
    font-size: 0.88rem;
}

.atlas-cart {
    padding: 12px;
    background-color: white;
    margin: 12px;
    width: 100%;
}

.atlas-cart-table {
    width: 100%;
    font-size: 0.92rem;
}

.atlas-cart-item {
    transition: background-color 1s;
    will-change: background-color;
}

.table-striped tbody tr.atlas-cart-item--error {
    background-color: #ffcccc;
}

.table-striped tbody tr.atlas-cart-item--deleting {
    opacity: 0.2;
}

.table-striped tbody tr.atlas-cart-item--updating {
    background-color: #ffff99;
}

.atlas-cart-item-delete {
    width: 30px;
}

.atlas-cart-item-part-description-container {
    display: flex;
}

.atlas-cart-item-image-container {
    position: relative;
    display: flex;
    width: 250px;
}

.atlas-cart-item-part-description-title {
    font-weight: bold;
}

.atlas-cart-item-availability {
    width: 190px;
}

.atlas-cart-item-availability-warehouse {
    display: flex;
    align-items: center;
}

.atlas-cart-item-availability-check,
.atlas-cart-item-availability-times {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.atlas-cart-item-quantity {
    width: 100px;
}

.atlas-cart-item-unit-price-cell {
    text-align: right;
    width: 150px;
}

.atlas-cart-item-unit-price {
    font-weight: bold;
}

.atlas-cart-item-extended-price {
    width: 150px;
    font-weight: bold;
    text-align: right;
}

.atlas-medium-button {
    background-color: #2A7013;
    color: white;
    border-radius: 3px;
    padding: 6px 16px;
    font-size: 1.1rem;
    letter-spacing: 0.5px;
    box-shadow: 2px 2px 3px #bbb;
}

.atlas-small-button {
    background-color: #eee;
    border: 1px solid #ccc;
    color: black;
    border-radius: 3px;
    padding: 4px 10px;
    font-size: 0.8rem;
    letter-spacing: 0.5px;
}

.atlas-small-button:hover {
    background-color: #ddd;
}

.atlas-add-to-cart-button {
    background-color: #2A7013;
    color: white;
    border-radius: 3px;
    text-transform: uppercase;
    padding: 3px 10px;
    letter-spacing: 0.5px;
    box-shadow: 2px 2px 3px #bbb;
}
.atlas-add-to-cart-button:disabled{
    background-color: #62776d;
    color: white
}

.atlas-add-to-cart-button-label {
    font-size: 0.8rem;
}

.atlas-add-to-cart-button:hover .atlas-add-to-cart-button-label {}

.atlas-add-to-cart-button:active {
    padding: 4px 9px 2px 11px;
}

.InfiniteScroll {}

.datePicker {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #ccc
}

.react-datepicker__input-container {
    display: initial !important;
}

.react-datepicker-wrapper {
    display: initial !important;
}

.InfiniteScroll-loader {
    margin: 100px auto 0;
    width: 70px;
    text-align: center;
}

.InfiniteScroll-loader>img {
    width: 30px;
    height: 30px;
}

@-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0)
    }
    40% {
        -webkit-transform: scale(1.0)
    }
}

@keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}

.WebOrders {
    padding: 16px;
}

.button-reset-style {
    border: none;
}

.Lightbox-close-button {
    float: right;
}

.Lightbox-background {
    text-align: center;
}

.UnreadMessageAlertModalClose {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 30px;
    height: 30px;
    border: 1px solid #D32F2F;
    border-radius: 15px;
    background-color: #D32F2F;
    text-align: center;
    font: normal normal bold 20px/20px Arial;
    letter-spacing: 0px;
    color: #FFFFFF;
}

.leftModalContainer {
    position: fixed;
    width: 300px;
    height: 350px;
    overflow:hidden;
}

.leftModalImage {
    position: absolute;
    top: 0px;
    left: -104px;
    width: 525px;
    height: 350px;
    background: transparent url("https://s3.amazonaws.com/atlastrailer.com/Popup/left.jpg") 0% 0% no-repeat padding-box;
    background-size: contain;
}

.rightModalContainer {
    position: fixed;
    left: 300px;
    width: 300px;
    height: 350px;
    overflow:hidden;
}

.rightModalPanel {
    position: absolute;
    top: -93px;
    left: -49px;
    width: 770px;
    height: 513px;
    background: transparent url('https://s3.amazonaws.com/atlastrailer.com/Popup/behind.jpg') 0% 0% no-repeat padding-box;
    background-size: contain;
    opacity: 0.09;
    z-index: 1;
}

.modalContent {
    width:100%;
    position: absolute;
    z-index: 2;
}

.UnreadMessageAlertPrimaryMessage {
    text-align: center;
    font: normal normal normal 25px/30px Impact;
    letter-spacing: 0px;
    position: absolute;
    top: 134px;
    right: 0px;
    width: 300px;
    color: #707070;
    opacity: 1;
}

.UnreadMessageAlertSecondaryMessage {
    text-align: center;
    font: normal normal normal 15px/20px Arial;
    letter-spacing: 0px;
    position: absolute;
    top: 233px;
    right: 0px;
    width: 300px;
    padding-left: 55px;
    padding-right: 55px;
    color: #707070;
    opacity: 1;
}

.UnreadMessageAlertModalGoTo {
    position: absolute;
    top: 307px;
    right: 0px;
    width: 172px;
    margin-right: 64px;
    height: 37px;
    background: #D32F2F;
    box-shadow: inset 20px 20px 20px #00000029, 5px 5px 50px #00000029;
    border-radius: 10px;
    opacity: 1;
    text-align: center;
    font: normal normal bold 15px/20px Arial;
    letter-spacing: 0px;
    color: #FFFFFF;
}

.UnreadMessageAlertInboxIcon {
    position: absolute;
    top: 51px;
    right: 119px;
    width: 62px;
    height: 62px;
    background: transparent url('https://s3.amazonaws.com/atlastrailer.com/Popup/email.png') 0% 0% no-repeat padding-box;
    background-size: contain;
    opacity: 1;
}

.atlas-retail-price {
    color: red;
}

.atlas-regular-price {
    text-decoration: line-through;
}

.atlas-clearance-price {
    color: blue;
}

.atlas-dealer-price {
    color: blue;
}

.atlas-products-compact {
    font-size: 0.92rem;
}

.atlas-app-inner {
    margin-top: 120px;
    z-index: -1;
    position: absolute;
    width: 100%;
    background-color: #F7F7F9;
}

.breadcrumb,
.pagination {
    margin-bottom: 12px;
    margin-top: 12px;
}

.atlas-cart-icon-quantity {
    padding-left: 4px;
    display: flex;
    justify-content: center;
    right: 0;
    top: 0;
    position: absolute;
    width: 33px;
}

.atlas-cart-icon-quantity-inner {
    min-width: 17px;
    padding: 1px 2px;
    display: inline-block;
    background-color: red;
    text-align: center;
    border-radius: 10px;
    color: white;
    font-size: 0.6rem;
}

.atlas-inbox-icon-quantity {
    padding-left: 4px;
    display: flex;
    justify-content: center;
    right: 0;
    top: 0;
    position: absolute;
    width: 20px;
}


/**
* Email Admin
**/

.atlas-email-admin-sidenav {
    height: 100%;
    width: 200px;
    position: fixed;
    z-index: 1;
    top: 110px;
    left: 0;
    background-color: #2D6F1B;
    overflow-x: hidden;
    padding: 60px 10px 0px 10px;
}

.atlas-menu-item-1 {
    padding: 16px 8px 6px 16px;
    text-decoration: none;
    font-size: 1rem;
    color: #FFF;
    opacity: 0.85;
    display: block
}

.atlas-menu-item-2 {
    padding: 2px 8px 2px 16px;
    text-decoration: none;
    font-size: .8rem;
    color: #FFF;
    opacity: 0.85;
    display: block
}

.atlas-email-admin-sidenav a:hover {
    background-color: #f1f1f1;
    color: #2D6F1B
}

.atlas-email-admin-main {
    margin-left: 200px;
    padding: 30px 60px;
}

.atlas-email-nav-search-form {
    max-height: 2.5rem;
    background-color: #F5F5F5;
    width: 25vw;
    box-shadow: 1px 1px 2px #ddd;
    transition: box-shadow 0.2s;
    align-items: center;
}

.atlas-email-nav-search-form.atlas-email-nav-search-form--focus {
    box-shadow: 1px 1px 5px #999;
    transition: box-shadow 0.2s;
}

.atlas-med-length {
    width: 250px;
}

.no-margin {
    margin: 0px
}

.atlas-push-right {
    float: right
}

#wrapper {
    display: flex;
}

#left {
    flex: 0 0 40%;
}

#right {
    margin-left: auto;
}

.email-admin-language-select {
    margin: 3px 10px 3px 20px;
}
.email-admin-search-input {
    border: 0 none;
    flex: 1;
    background-color: transparent;
    margin: 8px 14px;
    margin-left: 0;
    font-size: 1.1rem;
    color: black;
}
.email-admin-push-right {
    margin-left: 20px;
}

.atlas-email-admin-button {
    background-color: #2D6F1B;
    color: white;
    padding: 7px 12px;
    margin: 2px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    /*overwrite input default styling*/
    border-width: none;
    border-style: none;
    border-color: none;
}


/*remove link styling*/

.atlas-email-admin-button a:hover {
    text-decoration: none;
    color: #fff;
}

.paper-clip {
    align-self: end;
}

.attachment-label {
    font-weight: bold;
    font-size: 12px;
}

.align-end {
    justify-self: end;
}

.image-upload>input {
    display: none;
}

.grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
}

.grid-item {
    margin: 10px 0px 10px 0px;
}

.grid-item-height {
    height: 30px;
}


/* end email admin */


/**
  * Inbox
  */

.atlas-inbox-sidenav {
    height: 100%;
    width: 200px;
    position: fixed;
    z-index: 1;
    top: 110px;
    left: 0;
    background-color: #2D6F1B;
    overflow-x: hidden;
    padding-top: 60px;
}

.atlas-inbox-menu-item-1 {
    padding-top: 100px;
    text-decoration: none;
    font-size: 1.3rem;
    color: #FFF;
    opacity: 0.85;
    display: block;
    width: 200px;
}

.atlas-inbox-sidebar-container {
    display: flex;
}

.chat-svg {
    fill: #FFF;
    margin-right: 5px;
    margin-left: 10px;
    padding-top:8px;
}

.atlas-email-admin-table {
    margin: 0 20px 20px 20px;
}

.atlas-inbox-table {
    margin: 0 20px 20px 20px;
}

.atlas-inbox-table th {
    background-color: #2D6F1B;
    color: #FFF;
}
.atlas-inbox-table tr:hover {
    background-color: #ccf0c1;
    cursor: pointer;
}

.atlas-inbox-table td {
    border-style: solid;
    border-width: 0 0 thin 0;
    border-color: #D8D8D8;
}

.atlas-inbox-thin-column {
    width: 20%;
}

.atlas-inbox-grid-leftHeader {
    grid-area: header;
}

.atlas-inbox-grid-rightHeader {
    grid-area: rightHeader;
}

.atlas-inbox-grid-main {
    grid-area: main;
}

.atlas-inbox-main {
    display: grid;
    grid-template-areas: 'header header header header header rightHeader' 'main main main main main main';
    margin-left: 200px;
    margin-right: 40px;
}

.atlas-inbox-pagination {
    margin: 0;
    margin-top: 30px;
}

.atlas-inbox-main #right-header {
    text-align: right;
}

.atlas-inbox-sidebar-container a {
    color: #FFF;
    text-decoration: none;
    width: 200px;
}

.inbox-row-unread {
    background-color: #E8E8E8;
}

.inbox-row-read {
    background-color: white;
}

.accounting-address-table {
    max-height: 100px;
    overflow: auto;   
}


.textGreen {
    color: green
}
.textRed {
    color: red
}

/* compose stylying */
.atlas-compose-editor {
    height: auto;
    min-height: 300px;
}

/* ReactQuill editor styles */
.atlas-compose-editor .ql-editor {
    min-height: 200px;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
}

.atlas-compose-editor .ql-toolbar {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    background-color: #f8f9fa;
}

.atlas-compose-editor .ql-container {
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    font-family: Arial, sans-serif;
}

.wrapper-class {
    padding: .1rem;
    height: 300px;
  }
  .editor-class {
    background-color: white;
    padding: 1rem;
    border: 1px solid #ccc;
  }
  .toolbar-class {
    border: 1px solid #ccc;
  }

  .send-disabled {
    pointer-events: none; 
    opacity: 25%;
  }
  
  .report-label {
    margin: 10px;
  }

  .delete-x {
    padding-left: 30px;
    color: #e91131;
  }

  /* Reports */
  .nice-outline {
    border-style: solid;
    border-color: grey;
    border-width: 2px;
    border-radius: 10px;
    padding:20px;
    background-color:	#F0F0F0;
  } 
  .centre-screen {
    display: flex; 
    justify-content: center;
  }
  .slide-right {
    
    display: flex; 
    justify-content: flex-end;
    margin-top: 50px;
  }

/* inbox messages */

.atlas-inbox-message-main {
    margin: 0 0 0 200px;
    padding-top: 100px;
    background-color: #F0F0F0;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 1rem;

}
.atlas-inbox-message-body {
    max-width: 600px;
}

.atlas-inbox-grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 100%;
}

.inbox-message-sidebar-icon{
    padding-bottom: 3px;
}

.atlas-inbox-grid-item {
    margin: 10px 20px 10px 20px;
}
.atlas-inbox-green-heading {
    background-color: #2D6F1B;
    text-align: center;
    color: white;
    padding: 5px;
    box-shadow: 2px 5px #E0E0E0;
    min-width: 150px;
    max-width: 200px;
    height: 40px;
    justify-self: end;
}

.atlas-inbox-message-body {
    background-color: white;
    border-style: solid;
}

.atlas-inbox-message-attachment{
    background-color: white;
    overflow: auto;
}
 .inbox-message-sidenav-text{
     height: 80px;
     padding: 6px;
 }

 .inbox-message-textarea{
    margin: 5px;
    padding: 20px;
    height: 30rem;
    width: 100%;
    min-width: 20rem;
    background-color: white;
    border-style: solid;
    border-width: thin;
    overflow: auto;
 }
/* end inbox */

.category-items {
    display: flex;
    list-style-type: '/ ';
    gap: 1rem;
}

.category-items li:first-child {
    list-style-type: none;
}
`, "",{"version":3,"sources":["webpack://./client/common/app.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,oFAAoF;IACpF,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,OAAO;IACP,MAAM;IACN,0FAA0F;IAC1F,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,OAAO;IACP,MAAM;IACN,2FAA2F;IAC3F,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;;kFAEkF;;AAElF,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8CAA8C;AAClD;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;;IAEI,0CAA0C;IAC1C,YAAY;IACZ,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;;kFAEkF;;AAElF;IACI,wBAAwB;IACxB;QACI,aAAa;IACjB;;IAEA,2CAA2C;IAC3C;QACI,eAAe;QACf,SAAS;QACT,WAAW;QACX,WAAW;QACX,0BAA0B;QAC1B,yBAAyB;QACzB,sBAAsB;QACtB,2BAA2B;QAC3B,oBAAoB;QACpB,eAAe;QACf,0BAA0B;QAC1B,aAAa;QACb,gBAAgB;QAChB,yCAAyC;IAC7C;;IAEA,+BAA+B;IAC/B;QACI,OAAO;IACX;;IAEA,4BAA4B;IAC5B;;QAEI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,iDAAiD;IACrD;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;IAC/C;;IAEA,+BAA+B;IAC/B;QACI,cAAc;QACd,gBAAgB;QAChB,8CAA8C;QAC9C,iBAAiB;IACrB;AACJ;;AAEA,6DAA6D;AAC7D;IACI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;GAEG;;AAEH;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;AACzB;;AAEA;;;IAGI,YAAY;IACZ,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,+BAA+B;IAC/B,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;QACQ,eAAe;MACjB,WAAW;MACX,kBAAkB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;MAChB,eAAe;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA,0BAA0B;;AAE1B;;;IAGI,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iEAAiE;;AAEjE;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;;AAEjB;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;;;QAGI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;;;QAGI,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,6BAA6B;QAC7B,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mHAAmH;IACnH,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qHAAqH;IACrH,wBAAwB;IACxB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kEAAkE;IAClE,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,oHAAoH;IACpH,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,WAAW;AACf;;;AAGA;;EAEE;;AAEF;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;IACV,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA,sBAAsB;;AAEtB;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;;AAGA,oBAAoB;;;AAGpB;;GAEG;;AAEH;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;IACV,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qGAAqG;IACrG,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI;AACJ;AACA;IACI;AACJ;;AAEA,qBAAqB;AACrB;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,YAAY;EACZ;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;;IAEE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;AAEF,mBAAmB;;AAEnB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,wDAAwD;IACxD,eAAe;;AAEnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;CACC;KACI,YAAY;KACZ,YAAY;CAChB;;CAEA;IACG,WAAW;IACX,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;CACjB;AACD,cAAc;;AAEd;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["html,\nbody {\n    background-color: #F7F7F9;\n    font-size: 16px;\n}\n\nh1 {\n    font-size: 1.5rem;\n}\n\nh2 {\n    font-size: 1.3rem;\n    margin-top: 18px;\n}\n\nh3 {\n    font-size: 1.15rem;\n    margin-top: 18px;\n}\n\nh4 {\n    font-size: 1.05rem;\n}\n\n/* Loading spinner animations */\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.sr-only {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n/* Products loading states */\n.products-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  font-size: 16px;\n  color: #666;\n}\n\n/* Pagination improvements for mobile responsiveness */\nnav[aria-label=\"Page navigation example\"] {\n  position: relative !important;\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 10px !important;\n  z-index: 1 !important;\n}\n\n@media (min-width: 768px) {\n  nav[aria-label=\"Page navigation example\"] {\n    position: absolute !important;\n    top: 135px !important;\n    right: 50px !important;\n    flex-direction: row !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n}\n\nnav[aria-label=\"Page navigation example\"] .form-group {\n  padding-top: 5px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  margin-bottom: 0 !important;\n}\n\nnav[aria-label=\"Page navigation example\"] .pagination {\n  margin-bottom: 0 !important;\n  flex-wrap: wrap !important;\n  justify-content: center !important;\n}\n\n/* Ensure pagination items don't get too small on mobile */\n@media (max-width: 767px) {\n  nav[aria-label=\"Page navigation example\"] .pagination .page-link {\n    padding: 8px 12px !important;\n    min-width: 40px !important;\n    text-align: center !important;\n  }\n}\n\n.btn-group {\n    /*z-index: 0;*/\n}\n\n.hover:hover {\n    cursor: pointer\n}\n\n.pagination>li.active>a {\n    background-color: #2A7013 !important;\n    color: white;\n    border: 1px solid #ECEEEF !important;\n}\n\n.pagination>li.active>a:hover {\n    background-color: #2A7013;\n    color: white;\n    border: 1px solid #ECEEEF;\n}\n\n.navbar-fixed-top {\n    background-color: white;\n    /*z-index: 2;*/\n}\n\n.atlas-detailed-list {}\n\n.new-badge, .clearance-badge, .scratch-and-dent-badge {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #2A7013;\n    background: url('https://atlastrailer.s3.amazonaws.com/img/new-badge.png') no-repeat;\n    background-size: contain;\n    color: white;\n    padding: 2px 4px;\n    font-size: 0.8rem;\n    margin-top: -10px;\n    border-radius: 2px;\n    width: 80px;\n    height: 140px;\n}\n\n.small {\n    width: 50px;\n    height: 85px;\n}\n\n.clearance-badge{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    left: 0;\n    top: 0;\n    background: url('https://atlastrailer.s3.amazonaws.com/img/clearance-badge.png') no-repeat;\n    background-size: contain;\n    margin-left: -10px;\n    width: 90px;\n    height: 140px;\n}\n\n.scratch-and-dent-badge {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    left: 0;\n    top: 0;\n    background: url('https://atlastrailer.s3.amazonaws.com/img/scratch-and-dent.png') no-repeat;\n    background-size: contain;\n    margin-left: -8px;\n    margin-top: -25px;\n    width: 99px;\n    height: 151px;\n}\n\n.atlas-detailed-list-product {\n    position: relative;\n    background-color: white;\n    display: flex;\n    padding: 12px;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    box-shadow: 1px 1px 2px #ddd;\n}\n\n.atlas-primary-nav-search-form {\n    background-color: #F5F5F5;\n    padding: 0;\n    display: flex;\n    margin: 0;\n    width: 50vw;\n    box-shadow: 1px 1px 2px #ddd;\n    transition: box-shadow 0.2s;\n    align-items: center;\n}\n\n.atlas-primary-nav-search-form.atlas-primary-nav-search-form--focus {\n    box-shadow: 1px 1px 5px #999;\n    transition: box-shadow 0.2s;\n}\n\n.atlas-select {\n    height: 30px\n}\n\n.atlas-search-input {\n    border: 0 none;\n    flex: 1;\n    background-color: transparent;\n    margin: 8px 14px;\n    margin-left: 0;\n    font-size: 1.1rem;\n    color: black;\n}\n\n.atlas-search-input-icon {\n    margin-left: 18px;\n    margin-right: 18px;\n    height: 18px;\n}\n\n.atlas-search-input:focus {\n    outline: 0;\n}\n\n.atlas-search-input::-webkit-input-placeholder,\n.atlas-search-input::-moz-placeholder,\n.atlas-search-input:-ms-input-placeholder {\n    color: black;\n}\n\n.atlas-primary-nav {\n    overflow: auto;\n    display: flex;\n    align-items: center;\n    padding: 16px;\n}\n\n.atlas-primary-nav-logo {\n    flex: 1;\n    margin-left: 12px;\n}\n\n.atlas-secondary-nav {\n    background-color: #2D6F1B;\n    overflow: visible;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px 12px;\n    font-size: 0.92rem;\n    transition: all 0.5s ease;\n    min-height: 32px;\n    flex-wrap: nowrap;\n    position: relative;\n}\n\n/* Mobile Navigation Styles */\n/* =============================================================================\n   NAVIGATION SYSTEM - Clean rebuild\n   ============================================================================= */\n\n/* Base Navigation Container */\n.atlas-secondary-nav {\n    position: relative;\n    background-color: #2D6F1B;\n    padding: 0 15px;\n    min-height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n/* Mobile Navigation Toggle (Hamburger) */\n.atlas-mobile-nav-toggle {\n    display: none;\n    flex-direction: column;\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    z-index: 1001;\n    position: relative;\n}\n\n.atlas-hamburger-line {\n    width: 24px;\n    height: 3px;\n    background-color: white;\n    margin: 2px 0;\n    transition: 0.3s ease;\n    display: block;\n}\n\n/* Hamburger Animation */\n.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(1) {\n    transform: rotate(-45deg) translate(-5px, 6px);\n}\n\n.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(2) {\n    opacity: 0;\n}\n\n.atlas-mobile-nav-toggle.open .atlas-hamburger-line:nth-child(3) {\n    transform: rotate(45deg) translate(-5px, -6px);\n}\n\n/* Desktop Navigation Content */\n.atlas-nav-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.atlas-nav-content ul.nav {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    align-items: center;\n}\n\n.atlas-nav-content ul.navbar-nav {\n    flex-direction: row;\n}\n\n.atlas-nav-content li.nav-item {\n    margin: 0 2px;\n}\n\n.atlas-secondary-nav-link {\n    display: inline-block;\n    padding: 12px 16px;\n    color: white;\n    text-decoration: none;\n    font-size: 16px;\n    font-weight: 500;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    white-space: nowrap;\n}\n\n.atlas-secondary-nav-link:hover,\n.atlas-secondary-nav-link:focus {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: white;\n    text-decoration: none;\n}\n\n/* Right-side navigation */\n.atlas-nav-content .pull-right {\n    margin-left: auto;\n}\n\n/* Mobile Overlay */\n.atlas-nav-overlay {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n.atlas-nav-overlay--visible {\n    display: block;\n}\n\n/* =============================================================================\n   MOBILE RESPONSIVE DESIGN\n   ============================================================================= */\n\n@media (max-width: 992px) {\n    /* Show hamburger menu */\n    .atlas-mobile-nav-toggle {\n        display: flex;\n    }\n    \n    /* Transform nav content into mobile menu */\n    .atlas-nav-content {\n        position: fixed;\n        top: 84px;\n        left: -100%;\n        width: 100%;\n        height: calc(100vh - 84px);\n        background-color: #2D6F1B;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: stretch;\n        padding: 20px 0;\n        transition: left 0.3s ease;\n        z-index: 1000;\n        overflow-y: auto;\n        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);\n    }\n    \n    /* Show mobile menu when open */\n    .atlas-nav-content--open {\n        left: 0;\n    }\n    \n    /* Mobile navigation lists */\n    .atlas-nav-content ul.nav,\n    .atlas-nav-content ul.navbar-nav {\n        flex-direction: column;\n        width: 100%;\n        margin: 0 0 20px 0;\n    }\n    \n    .atlas-nav-content li.nav-item {\n        width: 100%;\n        margin: 0;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    \n    .atlas-secondary-nav-link {\n        padding: 18px 20px;\n        width: 100%;\n        text-align: left;\n        display: block;\n        font-size: 18px;\n        white-space: normal;\n    }\n    \n    .atlas-secondary-nav-link:hover {\n        background-color: rgba(255, 255, 255, 0.15);\n    }\n    \n    /* Right navigation in mobile */\n    .atlas-nav-content .pull-right {\n        margin-left: 0;\n        margin-top: 20px;\n        border-top: 2px solid rgba(255, 255, 255, 0.2);\n        padding-top: 20px;\n    }\n}\n\n/* Additional responsive breakpoint for tablet optimization */\n@media (max-width: 1200px) and (min-width: 993px) {\n    .atlas-secondary-nav {\n        padding: 0 8px;\n    }\n    \n    .atlas-secondary-nav-link {\n        padding: 8px 10px;\n        font-size: 15px;\n    }\n}\n\n.atlas-super-list {\n    list-style: decimal !important;\n    /* color: forestgreen; */\n    margin-left: 1rem;\n}\n\n/* .atlas-secondary-nav li.active-link {\n    background-color: #1e500e;\n} */\n\n.atlas-compact-item-hover,\n.table-striped tbody tr:nth-of-type(odd).atlas-compact-item-hover {\n    background-color: #eee;\n}\n\n.atlas-primary-nav-cart-icon-container {\n    display: flex;\n    flex: 1;\n    justify-content: end;\n    align-items: center;\n    text-align: right;\n    margin-right: 12px;\n    max-width: 40px;\n}\n\n.atlas-primary-nav-inbox-icon-container {\n    display: flex;\n    flex: 1;\n    justify-content: end;\n    align-items: center;\n    text-align: right;\n    margin-right: 12px;\n}\n\n.atlas-primary-nav-cart-icon-link {\n    flex: 1;\n    position: relative;\n}\n\n.atlas-primary-nav-cart-icon {\n    height: 30px;\n}\n\n.atlas-secondary-nav-link {\n    background: transparent;\n    border: 0 none;\n    padding: 8px 12px;\n    color: white;\n    opacity: 0.85;\n    white-space: nowrap;\n    display: block;\n}\n\n.atlas-secondary-nav-link:hover {\n    color: white;\n    opacity: 1;\n    text-decoration: none;\n}\n\n.atlas-secondary-nav-link.active,\n.atlas-secondary-nav-link:focus,\n.atlas-secondary-nav-link:active {\n    color: white;\n    opacity: 1;\n    text-decoration: none;\n}\n\n.atlas-products {\n    flex: 1;\n    padding: 12px;\n    padding-top: 0;\n}\n\n.atlas-login-error {\n    color: red;\n    font-size: 0.9rem;\n    margin-top: 12px;\n}\n\n.atlas-login-logo {\n    width: 238px;\n    height: 66px;\n}\n\nbutton {\n    padding: 0;\n    border: 0 none;\n    background-color: transparent;\n}\n\n.atlas-list-nav {\n    background-color: #F7F7F9;\n    width: 100%;\n    margin-top: 12px;\n    margin-bottom: 12px;\n}\n\n.atlas-list-toggle {\n    font-size: 0.9rem;\n    border-radius: 4px;\n    overflow: hidden;\n    border: 1px solid #ECEEEF;\n    box-shadow: 0px 0px 2px #ddd;\n    -webkit-transition: all 0.1s;\n    transition: all 0.1s;\n}\n\n.atlas-list-toggle:focus {\n    outline: none;\n    border-color: #7DBBFD;\n    box-shadow: 0px 0px 3px #7DBBFD;\n    -webkit-transition: all 0.1s;\n    transition: all 0.1s;\n}\n\n.atlas-list-toggle:active {\n    outline: none;\n    border: 1px solid #7DBBFD;\n    box-shadow: 0px 0px 9px #7DBBFD;\n    -webkit-transition: all 0.1s;\n    transition: all 0.1s;\n}\n\n.atlas-list-toggle-option {\n    display: inline-flex;\n    background-color: white;\n    padding: 4px 12px;\n}\n\n.atlas-list-toggle-option--active {\n    background-color: #2A7013;\n    color: white;\n}\n\n.atlas-detailed-result {\n    padding: 4px 8px;\n}\n\n.atlas-detailed-result-title {\n    font-size: 1.1rem;\n}\n\n.atlas-detailed-list-product-image-container {\n        max-width: 100%;\n      width:250px;\n      margin-right: 12px;\n    text-align: center;\n}\n\n.atlas-detailed-list-product-image {\n    object-fit:contain;           \n      max-width: 100%;\n    width:250px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.atlas-detailed-list-product-info {\n    flex: 1;\n}\n\n.atlas-detailed-result-description {\n    font-size: 0.85rem;\n}\n\n.atlas-detailed-result-mfg {\n    color: #2A7013;\n}\n\n.atlas-detailed-result-table {\n    table-layout: fixed;\n    margin-top: 8px;\n    margin-bottom: 0;\n}\n\n.atlas-no-results {\n    font-size: 1.5rem;\n    margin-top: 100px;\n    text-align: center;\n}\n\n\n/* bootstrap override :( */\n\n.breadcrumb>.active,\n.breadcrumb>.active a:active,\n.breadcrumb>.active a:focus {\n    font-weight: bold;\n    text-decoration: none;\n    color: #0275d8;\n}\n\n.CategoryChildren-list {\n    background-color: white;\n    margin-bottom: 16px;\n    padding: 12px 32px;\n    margin-top: 12px;\n}\n\n.CategoryChildren-filled-list-item {\n    margin-bottom: 16px;\n}\n\n.CategoryChildren-filled-list-item-link {\n    color: black;\n    font-weight: bold;\n}\n\n.CategoryChildren-list-item-link:hover {\n    color: inherit;\n}\n\n.CategoryChildren-columned-list {\n    list-style: none;\n    padding-left: 16px;\n    -webkit-columns: 275px 4;\n    -moz-columns: 275px 4;\n    columns: 275px 4;\n}\n\n.CategoryChildren-list-item {\n    -webkit-column-break-inside: avoid;\n    page-break-inside: avoid;\n    break-inside: avoid;\n}\n\n.CategoryGrandchildren-list {\n    font-size: 0.88rem;\n}\n\n.atlas-cart {\n    padding: 12px;\n    background-color: white;\n    margin: 12px;\n    width: 100%;\n}\n\n.atlas-cart-table {\n    width: 100%;\n    font-size: 0.92rem;\n}\n\n.atlas-cart-item {\n    transition: background-color 1s;\n    will-change: background-color;\n}\n\n.table-striped tbody tr.atlas-cart-item--error {\n    background-color: #ffcccc;\n}\n\n.table-striped tbody tr.atlas-cart-item--deleting {\n    opacity: 0.2;\n}\n\n.table-striped tbody tr.atlas-cart-item--updating {\n    background-color: #ffff99;\n}\n\n.atlas-cart-item-delete {\n    width: 30px;\n}\n\n.atlas-cart-item-part-description-container {\n    display: flex;\n}\n\n.atlas-cart-item-image-container {\n    position: relative;\n    display: flex;\n    width: 250px;\n}\n\n.atlas-cart-item-part-description-title {\n    font-weight: bold;\n}\n\n.atlas-cart-item-availability {\n    width: 190px;\n}\n\n.atlas-cart-item-availability-warehouse {\n    display: flex;\n    align-items: center;\n}\n\n.atlas-cart-item-availability-check,\n.atlas-cart-item-availability-times {\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n}\n\n.atlas-cart-item-quantity {\n    width: 100px;\n}\n\n.atlas-cart-item-unit-price-cell {\n    text-align: right;\n    width: 150px;\n}\n\n.atlas-cart-item-unit-price {\n    font-weight: bold;\n}\n\n.atlas-cart-item-extended-price {\n    width: 150px;\n    font-weight: bold;\n    text-align: right;\n}\n\n.atlas-medium-button {\n    background-color: #2A7013;\n    color: white;\n    border-radius: 3px;\n    padding: 6px 16px;\n    font-size: 1.1rem;\n    letter-spacing: 0.5px;\n    box-shadow: 2px 2px 3px #bbb;\n}\n\n.atlas-small-button {\n    background-color: #eee;\n    border: 1px solid #ccc;\n    color: black;\n    border-radius: 3px;\n    padding: 4px 10px;\n    font-size: 0.8rem;\n    letter-spacing: 0.5px;\n}\n\n.atlas-small-button:hover {\n    background-color: #ddd;\n}\n\n.atlas-add-to-cart-button {\n    background-color: #2A7013;\n    color: white;\n    border-radius: 3px;\n    text-transform: uppercase;\n    padding: 3px 10px;\n    letter-spacing: 0.5px;\n    box-shadow: 2px 2px 3px #bbb;\n}\n.atlas-add-to-cart-button:disabled{\n    background-color: #62776d;\n    color: white\n}\n\n.atlas-add-to-cart-button-label {\n    font-size: 0.8rem;\n}\n\n.atlas-add-to-cart-button:hover .atlas-add-to-cart-button-label {}\n\n.atlas-add-to-cart-button:active {\n    padding: 4px 9px 2px 11px;\n}\n\n.InfiniteScroll {}\n\n.datePicker {\n    width: 100%;\n    border-radius: 5px;\n    border: 1px solid #ccc\n}\n\n.react-datepicker__input-container {\n    display: initial !important;\n}\n\n.react-datepicker-wrapper {\n    display: initial !important;\n}\n\n.InfiniteScroll-loader {\n    margin: 100px auto 0;\n    width: 70px;\n    text-align: center;\n}\n\n.InfiniteScroll-loader>img {\n    width: 30px;\n    height: 30px;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n        -webkit-transform: scale(0)\n    }\n    40% {\n        -webkit-transform: scale(1.0)\n    }\n}\n\n@keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n    }\n    40% {\n        -webkit-transform: scale(1.0);\n        transform: scale(1.0);\n    }\n}\n\n.WebOrders {\n    padding: 16px;\n}\n\n.button-reset-style {\n    border: none;\n}\n\n.Lightbox-close-button {\n    float: right;\n}\n\n.Lightbox-background {\n    text-align: center;\n}\n\n.UnreadMessageAlertModalClose {\n    position: absolute;\n    top: -15px;\n    right: -15px;\n    width: 30px;\n    height: 30px;\n    border: 1px solid #D32F2F;\n    border-radius: 15px;\n    background-color: #D32F2F;\n    text-align: center;\n    font: normal normal bold 20px/20px Arial;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n}\n\n.leftModalContainer {\n    position: fixed;\n    width: 300px;\n    height: 350px;\n    overflow:hidden;\n}\n\n.leftModalImage {\n    position: absolute;\n    top: 0px;\n    left: -104px;\n    width: 525px;\n    height: 350px;\n    background: transparent url(\"https://s3.amazonaws.com/atlastrailer.com/Popup/left.jpg\") 0% 0% no-repeat padding-box;\n    background-size: contain;\n}\n\n.rightModalContainer {\n    position: fixed;\n    left: 300px;\n    width: 300px;\n    height: 350px;\n    overflow:hidden;\n}\n\n.rightModalPanel {\n    position: absolute;\n    top: -93px;\n    left: -49px;\n    width: 770px;\n    height: 513px;\n    background: transparent url('https://s3.amazonaws.com/atlastrailer.com/Popup/behind.jpg') 0% 0% no-repeat padding-box;\n    background-size: contain;\n    opacity: 0.09;\n    z-index: 1;\n}\n\n.modalContent {\n    width:100%;\n    position: absolute;\n    z-index: 2;\n}\n\n.UnreadMessageAlertPrimaryMessage {\n    text-align: center;\n    font: normal normal normal 25px/30px Impact;\n    letter-spacing: 0px;\n    position: absolute;\n    top: 134px;\n    right: 0px;\n    width: 300px;\n    color: #707070;\n    opacity: 1;\n}\n\n.UnreadMessageAlertSecondaryMessage {\n    text-align: center;\n    font: normal normal normal 15px/20px Arial;\n    letter-spacing: 0px;\n    position: absolute;\n    top: 233px;\n    right: 0px;\n    width: 300px;\n    padding-left: 55px;\n    padding-right: 55px;\n    color: #707070;\n    opacity: 1;\n}\n\n.UnreadMessageAlertModalGoTo {\n    position: absolute;\n    top: 307px;\n    right: 0px;\n    width: 172px;\n    margin-right: 64px;\n    height: 37px;\n    background: #D32F2F;\n    box-shadow: inset 20px 20px 20px #00000029, 5px 5px 50px #00000029;\n    border-radius: 10px;\n    opacity: 1;\n    text-align: center;\n    font: normal normal bold 15px/20px Arial;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n}\n\n.UnreadMessageAlertInboxIcon {\n    position: absolute;\n    top: 51px;\n    right: 119px;\n    width: 62px;\n    height: 62px;\n    background: transparent url('https://s3.amazonaws.com/atlastrailer.com/Popup/email.png') 0% 0% no-repeat padding-box;\n    background-size: contain;\n    opacity: 1;\n}\n\n.atlas-retail-price {\n    color: red;\n}\n\n.atlas-regular-price {\n    text-decoration: line-through;\n}\n\n.atlas-clearance-price {\n    color: blue;\n}\n\n.atlas-dealer-price {\n    color: blue;\n}\n\n.atlas-products-compact {\n    font-size: 0.92rem;\n}\n\n.atlas-app-inner {\n    margin-top: 120px;\n    z-index: -1;\n    position: absolute;\n    width: 100%;\n    background-color: #F7F7F9;\n}\n\n.breadcrumb,\n.pagination {\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n\n.atlas-cart-icon-quantity {\n    padding-left: 4px;\n    display: flex;\n    justify-content: center;\n    right: 0;\n    top: 0;\n    position: absolute;\n    width: 33px;\n}\n\n.atlas-cart-icon-quantity-inner {\n    min-width: 17px;\n    padding: 1px 2px;\n    display: inline-block;\n    background-color: red;\n    text-align: center;\n    border-radius: 10px;\n    color: white;\n    font-size: 0.6rem;\n}\n\n.atlas-inbox-icon-quantity {\n    padding-left: 4px;\n    display: flex;\n    justify-content: center;\n    right: 0;\n    top: 0;\n    position: absolute;\n    width: 20px;\n}\n\n\n/**\n* Email Admin\n**/\n\n.atlas-email-admin-sidenav {\n    height: 100%;\n    width: 200px;\n    position: fixed;\n    z-index: 1;\n    top: 110px;\n    left: 0;\n    background-color: #2D6F1B;\n    overflow-x: hidden;\n    padding: 60px 10px 0px 10px;\n}\n\n.atlas-menu-item-1 {\n    padding: 16px 8px 6px 16px;\n    text-decoration: none;\n    font-size: 1rem;\n    color: #FFF;\n    opacity: 0.85;\n    display: block\n}\n\n.atlas-menu-item-2 {\n    padding: 2px 8px 2px 16px;\n    text-decoration: none;\n    font-size: .8rem;\n    color: #FFF;\n    opacity: 0.85;\n    display: block\n}\n\n.atlas-email-admin-sidenav a:hover {\n    background-color: #f1f1f1;\n    color: #2D6F1B\n}\n\n.atlas-email-admin-main {\n    margin-left: 200px;\n    padding: 30px 60px;\n}\n\n.atlas-email-nav-search-form {\n    max-height: 2.5rem;\n    background-color: #F5F5F5;\n    width: 25vw;\n    box-shadow: 1px 1px 2px #ddd;\n    transition: box-shadow 0.2s;\n    align-items: center;\n}\n\n.atlas-email-nav-search-form.atlas-email-nav-search-form--focus {\n    box-shadow: 1px 1px 5px #999;\n    transition: box-shadow 0.2s;\n}\n\n.atlas-med-length {\n    width: 250px;\n}\n\n.no-margin {\n    margin: 0px\n}\n\n.atlas-push-right {\n    float: right\n}\n\n#wrapper {\n    display: flex;\n}\n\n#left {\n    flex: 0 0 40%;\n}\n\n#right {\n    margin-left: auto;\n}\n\n.email-admin-language-select {\n    margin: 3px 10px 3px 20px;\n}\n.email-admin-search-input {\n    border: 0 none;\n    flex: 1;\n    background-color: transparent;\n    margin: 8px 14px;\n    margin-left: 0;\n    font-size: 1.1rem;\n    color: black;\n}\n.email-admin-push-right {\n    margin-left: 20px;\n}\n\n.atlas-email-admin-button {\n    background-color: #2D6F1B;\n    color: white;\n    padding: 7px 12px;\n    margin: 2px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    /*overwrite input default styling*/\n    border-width: none;\n    border-style: none;\n    border-color: none;\n}\n\n\n/*remove link styling*/\n\n.atlas-email-admin-button a:hover {\n    text-decoration: none;\n    color: #fff;\n}\n\n.paper-clip {\n    align-self: end;\n}\n\n.attachment-label {\n    font-weight: bold;\n    font-size: 12px;\n}\n\n.align-end {\n    justify-self: end;\n}\n\n.image-upload>input {\n    display: none;\n}\n\n.grid-container {\n    display: grid;\n    grid-template-columns: auto auto auto;\n}\n\n.grid-item {\n    margin: 10px 0px 10px 0px;\n}\n\n.grid-item-height {\n    height: 30px;\n}\n\n\n/* end email admin */\n\n\n/**\n  * Inbox\n  */\n\n.atlas-inbox-sidenav {\n    height: 100%;\n    width: 200px;\n    position: fixed;\n    z-index: 1;\n    top: 110px;\n    left: 0;\n    background-color: #2D6F1B;\n    overflow-x: hidden;\n    padding-top: 60px;\n}\n\n.atlas-inbox-menu-item-1 {\n    padding-top: 100px;\n    text-decoration: none;\n    font-size: 1.3rem;\n    color: #FFF;\n    opacity: 0.85;\n    display: block;\n    width: 200px;\n}\n\n.atlas-inbox-sidebar-container {\n    display: flex;\n}\n\n.chat-svg {\n    fill: #FFF;\n    margin-right: 5px;\n    margin-left: 10px;\n    padding-top:8px;\n}\n\n.atlas-email-admin-table {\n    margin: 0 20px 20px 20px;\n}\n\n.atlas-inbox-table {\n    margin: 0 20px 20px 20px;\n}\n\n.atlas-inbox-table th {\n    background-color: #2D6F1B;\n    color: #FFF;\n}\n.atlas-inbox-table tr:hover {\n    background-color: #ccf0c1;\n    cursor: pointer;\n}\n\n.atlas-inbox-table td {\n    border-style: solid;\n    border-width: 0 0 thin 0;\n    border-color: #D8D8D8;\n}\n\n.atlas-inbox-thin-column {\n    width: 20%;\n}\n\n.atlas-inbox-grid-leftHeader {\n    grid-area: header;\n}\n\n.atlas-inbox-grid-rightHeader {\n    grid-area: rightHeader;\n}\n\n.atlas-inbox-grid-main {\n    grid-area: main;\n}\n\n.atlas-inbox-main {\n    display: grid;\n    grid-template-areas: 'header header header header header rightHeader' 'main main main main main main';\n    margin-left: 200px;\n    margin-right: 40px;\n}\n\n.atlas-inbox-pagination {\n    margin: 0;\n    margin-top: 30px;\n}\n\n.atlas-inbox-main #right-header {\n    text-align: right;\n}\n\n.atlas-inbox-sidebar-container a {\n    color: #FFF;\n    text-decoration: none;\n    width: 200px;\n}\n\n.inbox-row-unread {\n    background-color: #E8E8E8;\n}\n\n.inbox-row-read {\n    background-color: white;\n}\n\n.accounting-address-table {\n    max-height: 100px;\n    overflow: auto;   \n}\n\n\n.textGreen {\n    color: green\n}\n.textRed {\n    color: red\n}\n\n/* compose stylying */\n.atlas-compose-editor {\n    height: auto;\n    min-height: 300px;\n}\n\n/* ReactQuill editor styles */\n.atlas-compose-editor .ql-editor {\n    min-height: 200px;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.atlas-compose-editor .ql-toolbar {\n    border-top: 1px solid #ccc;\n    border-left: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n    background-color: #f8f9fa;\n}\n\n.atlas-compose-editor .ql-container {\n    border-bottom: 1px solid #ccc;\n    border-left: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n    font-family: Arial, sans-serif;\n}\n\n.wrapper-class {\n    padding: .1rem;\n    height: 300px;\n  }\n  .editor-class {\n    background-color: white;\n    padding: 1rem;\n    border: 1px solid #ccc;\n  }\n  .toolbar-class {\n    border: 1px solid #ccc;\n  }\n\n  .send-disabled {\n    pointer-events: none; \n    opacity: 25%;\n  }\n  \n  .report-label {\n    margin: 10px;\n  }\n\n  .delete-x {\n    padding-left: 30px;\n    color: #e91131;\n  }\n\n  /* Reports */\n  .nice-outline {\n    border-style: solid;\n    border-color: grey;\n    border-width: 2px;\n    border-radius: 10px;\n    padding:20px;\n    background-color:\t#F0F0F0;\n  } \n  .centre-screen {\n    display: flex; \n    justify-content: center;\n  }\n  .slide-right {\n    \n    display: flex; \n    justify-content: flex-end;\n    margin-top: 50px;\n  }\n\n/* inbox messages */\n\n.atlas-inbox-message-main {\n    margin: 0 0 0 200px;\n    padding-top: 100px;\n    background-color: #F0F0F0;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 1rem;\n\n}\n.atlas-inbox-message-body {\n    max-width: 600px;\n}\n\n.atlas-inbox-grid-container {\n    display: grid;\n    grid-template-columns: auto auto auto;\n    width: 100%;\n}\n\n.inbox-message-sidebar-icon{\n    padding-bottom: 3px;\n}\n\n.atlas-inbox-grid-item {\n    margin: 10px 20px 10px 20px;\n}\n.atlas-inbox-green-heading {\n    background-color: #2D6F1B;\n    text-align: center;\n    color: white;\n    padding: 5px;\n    box-shadow: 2px 5px #E0E0E0;\n    min-width: 150px;\n    max-width: 200px;\n    height: 40px;\n    justify-self: end;\n}\n\n.atlas-inbox-message-body {\n    background-color: white;\n    border-style: solid;\n}\n\n.atlas-inbox-message-attachment{\n    background-color: white;\n    overflow: auto;\n}\n .inbox-message-sidenav-text{\n     height: 80px;\n     padding: 6px;\n }\n\n .inbox-message-textarea{\n    margin: 5px;\n    padding: 20px;\n    height: 30rem;\n    width: 100%;\n    min-width: 20rem;\n    background-color: white;\n    border-style: solid;\n    border-width: thin;\n    overflow: auto;\n }\n/* end inbox */\n\n.category-items {\n    display: flex;\n    list-style-type: '/ ';\n    gap: 1rem;\n}\n\n.category-items li:first-child {\n    list-style-type: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
